import { authedFetch } from '@features/auth/api/authRefresh'

/**
 * POST /api/users/me/email/change-init (T-H3)。
 *
 * 新 email + 再導出した SRP material を送信する。確認メールは新 email に送信され、
 * クリック → /auth/verify-email でメールアドレスと SRP material が atomic に更新される。
 */
export interface ChangeEmailInitRequest {
  newEmail: string
  srpSalt: string
  srpVerifier: string
}

export interface ChangeEmailInitResponse {
  pendingEmail: string
}

export const changeEmailInit = (body: ChangeEmailInitRequest): Promise<ChangeEmailInitResponse> =>
  authedFetch<ChangeEmailInitResponse>('/users/me/email/change-init', {
    method: 'POST',
    body,
  })
